import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from '../../_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-footer-cexveg',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    @Input() sidebarId: string = 'sidebar';

    version: string;
    environment: string;
    copyrightYear: number;

    constructor(private configurationService: ConfigurationService) {}

    ngOnInit() {
        this.configurationService.getVersionNumber().subscribe(s => (this.version = s));
        this.configurationService.getEnvironment().subscribe(s => (this.environment = s));
        this.configurationService.getCopyrightYear().subscribe(y => (this.copyrightYear = y));
    }
}
